import axiosInstance from "../axiosInstance";

export const categoryForecastService = {
  /**
   * Poll the forecast status for a given batch.
   * Returns { batch_id, complete, items: [{ category_id, status, forecast_monthly, error }] }
   */
  poll: async (batchId) => {
    const response = await axiosInstance.get(
      `/category-forecast-status?batch_id=${encodeURIComponent(batchId)}`,
    );
    return response.data;
  },
};
